<script setup lang="ts">
const { headerTheme } = useHeaderNavigation()
const { t } = useI18n({ useScope: 'local' })
const { pageType, trackEvent } = useTracking()

const isOpen = ref(false)

const openMobileAppDropdown = () => {
  isOpen.value = true
  trackEvent({ event: 'download_app_header_click', page_type: pageType.value })
}
const closeMobileAppDropdown = () => {
  isOpen.value = false
}

onMounted(() => {
  document.addEventListener('scroll', closeMobileAppDropdown)
})
onUnmounted(() => {
  document.removeEventListener('scroll', closeMobileAppDropdown)
})
</script>

<template>
  <div v-click-outside="closeMobileAppDropdown" class="relative h-full">
    <button
      :class="[
        'rounded bg-gray-700/50 px-2 py-1 text-xs font-normal text-white outline-none backdrop-blur-lg',
        {
          'border border-gray-200 !bg-white !text-gray-700':
            headerTheme === 'white',
        },
      ]"
      type="button"
      @click="openMobileAppDropdown"
    >
      {{ t('cta') }}
    </button>

    <Transition name="fade">
      <div
        v-if="isOpen"
        :class="[
          'absolute right-0 top-[calc(100%+1.5rem)] mt-2 flex w-[450px] items-center gap-6 rounded bg-gray-700/50 p-6 text-white shadow-lg backdrop-blur-lg',
          {
            'border border-gray-200 bg-white !text-gray-700':
              headerTheme === 'white',
          },
        ]"
      >
        <BaseQrCodeApp
          v-if="headerTheme === 'white'"
          width="128"
          height="128"
          class="!size-32"
        />
        <img
          v-else
          alt="qr-code-app"
          class="size-32"
          height="128"
          loading="lazy"
          src="~/assets/images/qr-code-black.png"
          width="128"
        />
        <div class="flex flex-col gap-1 leading-normal">
          <p class="m-0 text-md font-bold">{{ t('title') }}</p>
          <p class="m-0 text-xs">{{ t('text') }}</p>

          <TheAppStoreLinks
            class="mt-3 gap-4"
            :size-image="{ height: 28, width: 91 }"
            source="header"
          />
        </div>
      </div>
    </Transition>
  </div>
</template>

<i18n lang="yaml">
fr:
  cta: Obtenir l'app
  title: Votre voyage dans la poche avec l'application Le Collectionist
  text: Découvrez des propriétés d'exception et accédez facilement aux informations clés de vos séjours ainsi qu'à tous nos services.
en:
  cta: Get the app
  title: Your trip in the palm of your hand with the Le Collectionist app
  text: Explore exceptional properties and easily access key information about your stays, along with all our services.
</i18n>
